module.exports = __webpack_public_path__ + "static/media/LemonTart.f0f69351.jpeg";